import { ApiRoutes } from "../../../../../constants/api";
import { BaseAPI, RequestMethod } from "../../../base";
import { HomepageImageRequestBody, HomepageImageResponse } from "./types";

export class HomepageImageAPI extends BaseAPI<
    HomepageImageRequestBody,
    HomepageImageResponse
> {
    protected route = ApiRoutes.home.image;
    protected method = RequestMethod.GET;
}
